import React from "react";
import { GlobalContextProvider } from "./src/context/GlobalContext";
import ConsentBanner from "./src/components/ConsentBanner";

import "@fontsource/montserrat";  // We use montserrat font
import "./src/styles/global.css";
import "./src/styles/print.css";


export const wrapRootElement = ({ element }) => (
  // We can wrap each page here
  <GlobalContextProvider>{element}</GlobalContextProvider>
);

// Per page rather than per root, so the banner can speak the page's language.
export const wrapPageElement = ({ element, props }) => (
  <>
    {element}
    <ConsentBanner language={props?.pageContext?.language || "en"} />
  </>
);